module.exports = "https://r.nearpod.com/assets/media/image/youtube-no-results-b988975ee2554f8e99d641ffc0883cf0.svg";